import {
  MENU_POST_ITEM,
  MENU_SERVICE_REQUEST_ITEM,
} from '../../../constants/menu'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { isMenuHomePageAvailable } from '../../../utils/menu'
import { isUnconfirmed } from '../../../utils/user'

export function getCompanyHomePageLink({
  availableSections,
  isDashboardAvailable,
  userData,
}) {
  if (userData && isUnconfirmed(userData)) {
    return MENU_SERVICE_REQUEST_ITEM.to
  }

  return isMenuHomePageAvailable({
    isDashboardAvailable,
    uiSections: availableSections,
  })
    ? MENU_POST_ITEM.to
    : `/${WEBAPP_ROUTE_PREFIX}`
}
